export default function accordionController() {
  // Select all accordion items
  const accordionItems = document.querySelectorAll('[data-accordion-item]');

  if (!accordionItems.length) {
    return;
  }

  accordionItems.forEach((item) => {
    const header = item.querySelector('[data-accordion-header]');
    const content = item.querySelector('[data-accordion-content]');

    // Спочатку приховуємо всі контенти
    if (!item.classList.contains('open')) {
      content.style.height = '0';
    }

    // Attach a click event to each header
    header.addEventListener('click', () => {
      if (!isSupportedOnCurrentDevice(item)) return;

      const isOpen = item.classList.contains('open');
      if (isOpen) {
        // Закриваємо
        const currentHeight = content.scrollHeight;
        content.style.height = currentHeight + 'px';

        requestAnimationFrame(() => {
          content.style.height = '0';
        });

        content.addEventListener(
          'transitionend',
          function handleClose() {
            item.classList.remove('open');
            content.removeEventListener('transitionend', handleClose);
          },
          { once: true }
        );
      } else {
        // Відкриваємо
        item.classList.add('open');

        // Важливо: тимчасово прибираємо display: none для вимірювання
        content.style.display = 'block';
        const height = content.scrollHeight;
        content.style.height = '0';

        requestAnimationFrame(() => {
          content.style.height = height + 'px';
        });

        content.addEventListener(
          'transitionend',
          function handleOpen() {
            content.style.height = 'auto';
            content.removeEventListener('transitionend', handleOpen);
          },
          { once: true }
        );
      }
    });
  });

  window.addEventListener(
    'resize',
    debounce(() => {
      accordionItems.forEach((item) => {
        const header = item.querySelector('[data-accordion-header]');
        const content = item.querySelector('[data-accordion-content]');

        if (isSupportedOnCurrentDevice(item)) {
          return;
        }

        header.classList.remove('open');
        content.style.removeProperty('height');
        content.style.removeProperty('display');
      });
    }, 250)
  );

  function isSupportedOnCurrentDevice(item) {
    const deviceType = String(item.dataset?.accordionItem);
    const worksOnMobile = deviceType.includes('mobile');
    const worksOnTablet = deviceType.includes('tablet');
    const worksOnDesktop = deviceType.includes('desktop');
    const worksEverywhere = !worksOnDesktop && !worksOnTablet && !worksOnMobile;

    const currentDeviceType = window.deviceType;
    const isSupported =
      worksEverywhere ||
      (currentDeviceType === 'mobile' && worksOnMobile) ||
      (currentDeviceType === 'tablet' && worksOnTablet) ||
      (currentDeviceType === 'desktop' && worksOnDesktop);

    return isSupported;
  }
}
